import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GlobalValidationService } from 'src/app/global-validation.service';

@Component({
  selector: 'app-add-to-wallet',
  templateUrl: './add-to-wallet.component.html',
  styleUrls: ['./add-to-wallet.component.scss']
})
export class AddToWalletComponent implements OnInit {
  agent_code: any = null;
  booth_code: any = null;
  business_details: any = null;
  business_available = false;
  payment_modes: Object;
  selected_payment_mode = 2
  add_money_form: FormGroup;
  amount: any;
  agent_id: any;
  min_date: string;
  transaction_history: Object;
  title: any;

  constructor(private global: GlobalService, private http: HttpService, private formBuilder: FormBuilder, ) {
    // this.global.set_master_page_title = 'Add To Wallet';
    this.title = this.global._active_display_name;

    let today = new Date();
    this.min_date = new Date(today).toISOString().split('T')[0];
    this.http.getPaymentModes().subscribe((data) => {
      console.log(data);
      this.payment_modes = data;

    })
    this.add_money_form = this.formBuilder.group({
      bank_name: [null, Validators.compose([Validators.required])],
      branch_name: [null, Validators.compose([Validators.required])],
      ifsc_code: [null, Validators.compose([Validators.required])],
      micr_code: [null],
      account_holder_name: [null, Validators.compose([Validators.required])],
      account_number: [null, Validators.compose([Validators.required])],
      cheque_issue_date: [null, Validators.compose([Validators.required])],
      cheque_number: [null, Validators.compose([Validators.required])],
    })
  }

  ngOnInit() {
  }

  checkBoothExists() {
    let data_dict = {
      'booth_code': this.booth_code,
      'agent_code': this.agent_code
    };
    console.log(data_dict);
    this.http.checkForBoothAndAgentExists(data_dict).subscribe((data) => {
      console.log(data);
      if (data['found']) {
        this.business_details = data;
        this.business_available = true;
        this.agent_id = data['agent_id']
        this.http.serveTransactionHistoryAgent({'agent_id': this.agent_id}).subscribe((his_data)=> {
          console.log(his_data)
          this.transaction_history = his_data
        })
      } else {
        this.booth_code = null;
        this.agent_code = null;
        this.business_details = null;
        this.business_available = false;
        alert('Agent not available');
      }
    }, (error) => {
      this.booth_code = null;
      this.agent_code = null;
      this.business_details = null;
      this.business_available = false;
      console.error(error);
    });
  }

  addMoney() {
    // this.amount = parseInt(this.amount)
    if (this.amount <= 0 || this.amount == null || this.amount == '' ) {
      alert('please enter a valid amount');
      this.amount = null;
      return false;
    }
    console.log(this.add_money_form.value)
    const data_dict = {
      'money': this.amount,
      'agent_id': this.agent_id,
      'mode':this.selected_payment_mode
    }

    if (this.selected_payment_mode == 3) {
      data_dict['cheque_details'] = this.add_money_form.value
    }
    this.http.AddMoneyToWallet(data_dict).subscribe((data)=> {
      console.log(data);
      this.global.showSnakeBar('money added to wallet')
      // this.business_available = false;
      this.selected_payment_mode = 2
      this.amount = null;
      // this.agent_code = null;
      // this.booth_code = null;
      this.checkBoothExists()
    },(error)=> {
      console.log(error);
    })
  }

  clearBankDetails() {
    this.add_money_form.controls['bank_name'].setValue(null);
    this.add_money_form.controls['branch_name'].setValue(null);
    this.add_money_form.controls['ifsc_code'].setValue(null);
    this.add_money_form.controls['micr_code'].setValue(null);
    this.add_money_form.controls['account_holder_name'].setValue(null);
    this.add_money_form.controls['account_number'].setValue(null);
    this.add_money_form.controls['cheque_issue_date'].setValue(null);
    this.add_money_form.controls['cheque_number'].setValue(null);

  }

  changePayment() {
    console.log(this.selected_payment_mode);
    if (this.selected_payment_mode == 3) {
      this.add_money_form.controls['bank_name'].setValue(this.business_details['bank_name']);
      this.add_money_form.controls['branch_name'].setValue(this.business_details['branch_name']);
      this.add_money_form.controls['ifsc_code'].setValue(this.business_details['ifsc_code']);
      this.add_money_form.controls['micr_code'].setValue(this.business_details['micr_code']);
      this.add_money_form.controls['account_holder_name'].setValue(this.business_details['account_holder_name']);
      this.add_money_form.controls['account_number'].setValue(this.business_details['account_number']);
      this.add_money_form.controls['cheque_issue_date'].setValue(null);
      this.add_money_form.controls['cheque_number'].setValue(null);
    }
  }
}
